import {SET_SUBSTANCE, SET_SUBSTANCES} from "../actions/substance";

const initialState = {
    substances: [],
    substance: null
};

export default (state=initialState, action) => {
    switch(action.type) {
        case SET_SUBSTANCES:
            return Object.assign({}, state, {
                substances: action.payload
            });

        case SET_SUBSTANCE:
            return Object.assign({}, state, {
                substance: action.payload
            });

        default:
            return state;
    }
}